import { Box, styled } from '@mui/material';

export const IndividualCostWrapperStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-evenly',

  // '@media (min-width: 744px)': {
  //   paddingBottom: '33px',
  // },
  '@media (min-width: 1024px)': {
    paddingLeft: '47px',
    paddingBottom: '33px',
  },
  'p:last-child': {
    marginBottom: '0px',
  },
});

export const TotalCostWrapperStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '@media (max-width: 743px)': {
    justifyContent: 'flex-end',
    flexDirection: 'row-reverse',
    borderBottom: '1px solid #dee2e6',
  },
  '@media (min-width: 1024px)': {
    paddingTop: '40px',
    paddingBottom: '33px',
  },
});

export const TotalCostStyled = styled(Box)({
  '@media (max-width: 743px)': {
    fontSize: '23px',
    fontWeight: '600',
    color: '#000',
  },
  '& h2': {
    fontSize: '46px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '140%',
    marginBottom: '0px',
  },
});

export const TotalCostTextStyled = styled('p')({
  '@media (max-width: 743px)': {
    margin: 'inherit',
    fontSize: '16px',
    paddingRight: '4px',
  },
});
